export type MetaDataKey =
  | "environmentName"
  | "sentryDsn"
  | "sentryEnvironment"
  | "sentryRelease"
  | "fullStoryOrgId"
  | "userEmail"
  | "userName"
  | "csrfToken"
  | "guardianToken"
  | "laboratoryFeatures"
  | "appcuesUserId"
  | "roles"
  | "tpsCars";

export const fetchMetaData = (field: MetaDataKey): string | null => {
  const element = document.querySelector(`meta[name=${field}]`);

  if (element) {
    return element.getAttribute("content");
  } else {
    return null;
  }
};
